module.exports = __webpack_public_path__ + "static/img/index.83e88dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/index.png
// module id = 110
// module chunks = 0